import { api } from './api';

const endpoint = '/media';

export const apiMedia = {

  async send_image(data){
    const url = `${endpoint}/process-image/`;
    const result = await api.post(url, data, {'Content-Type':' multipart/form-data'});
    return result.data;
  },
}